import { render } from "./edit-schedule.vue?vue&type=template&id=12d1febc"
import script from "./edit-schedule.vue?vue&type=script&lang=js"
export * from "./edit-schedule.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__